/* Riders Parts — product detail tabs / accordion.
 *
 * WHY THIS FILE EXISTS AT ALL: an inline <script> inside a section once printed
 * its own source as visible text on every page of this store. Section behavior
 * lives in assets/*.js on this theme, without exception.
 *
 * Two modes, one set of panels:
 *   desktop (>= 900px) — tab bar, exactly one panel open
 *   mobile             — accordion, each panel toggles independently
 * The tab bar and the accordion headers are both in the markup; CSS hides the
 * one that does not belong to the current mode, so no markup is rebuilt.
 *
 * Progressive enhancement: the section renders every panel OPEN with no JS.
 * Hiding only starts once this file adds .rp-pdx--js, so a script failure
 * degrades to a long-but-readable page rather than a blank one.
 */
(function () {
  var DESKTOP = '(min-width: 900px)';

  function setup(root) {
    if (root.getAttribute('data-rp-ready') === '1') return;
    root.setAttribute('data-rp-ready', '1');

    var panels = [].slice.call(root.querySelectorAll('[data-rp-panel]'));
    if (!panels.length) return;
    var tabs = [].slice.call(root.querySelectorAll('[data-rp-tab]'));
    var accs = [].slice.call(root.querySelectorAll('[data-rp-acc]'));

    root.classList.add('rp-pdx--js');

    function idOf(el, attr) {
      return el.getAttribute(attr);
    }

    function paint() {
      panels.forEach(function (panel) {
        var id = idOf(panel, 'data-rp-panel');
        var open = panel.classList.contains('is-open');
        var body = panel.querySelector('[data-rp-body]');
        if (body) {
          if (open) {
            body.removeAttribute('hidden');
          } else {
            body.setAttribute('hidden', '');
          }
        }
        accs.forEach(function (a) {
          if (idOf(a, 'data-rp-acc') === id) a.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        tabs.forEach(function (t) {
          if (idOf(t, 'data-rp-tab') !== id) return;
          t.setAttribute('aria-selected', open ? 'true' : 'false');
          t.setAttribute('tabindex', open ? '0' : '-1');
          t.classList.toggle('is-active', open);
        });
      });
    }

    function openOnly(id) {
      panels.forEach(function (p) {
        p.classList.toggle('is-open', idOf(p, 'data-rp-panel') === id);
      });
      paint();
    }

    function toggle(id) {
      panels.forEach(function (p) {
        if (idOf(p, 'data-rp-panel') === id) p.classList.toggle('is-open');
      });
      paint();
    }

    function isDesktop() {
      return window.matchMedia(DESKTOP).matches;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        openOnly(idOf(t, 'data-rp-tab'));
      });
      t.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        openOnly(idOf(next, 'data-rp-tab'));
        next.focus();
      });
    });

    accs.forEach(function (a) {
      a.addEventListener('click', function () {
        var id = idOf(a, 'data-rp-acc');
        if (isDesktop()) {
          openOnly(id);
        } else {
          toggle(id);
        }
      });
    });

    function closeAll() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      paint();
    }

    // Start state differs by mode, because the two modes are different controls.
    //
    // Desktop is a TAB BAR. A tab bar with nothing selected renders as a row of
    // tab labels above an empty box, so exactly one panel must stay open.
    //
    // Mobile is an ACCORDION, and an accordion's correct start state is closed:
    // the shopper picks what to expand. Manuel, 2026-09-22: "i do not like that
    // features is opened by default, it shouldnt". It also stopped Features
    // looking like the odd one out next to three collapsed headers.
    //
    // Re-applied on a mode change so a phone rotated to landscape never lands on
    // "three tabs all highlighted" or on a tab bar with no panel showing.
    function reset() {
      if (isDesktop()) {
        openOnly(idOf(panels[0], 'data-rp-panel'));
      } else {
        closeAll();
      }
    }
    reset();

    var mq = window.matchMedia(DESKTOP);
    var onChange = function () {
      reset();
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-rp-pdx]')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Buy-box links that point at a panel ("See the size guide", snippets/rp-fitcta.liquid,
  // data-rp-open="size") open that panel and scroll to it. Without JS the href anchor still jumps.
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-rp-open]') : null;
    if (!a) return;
    var id = a.getAttribute('data-rp-open');
    var panel = document.querySelector('[data-rp-pdx] [data-rp-panel="' + id + '"]');
    if (!panel) return;
    e.preventDefault();
    var desktop = window.matchMedia(DESKTOP).matches;
    var tab = document.querySelector('[data-rp-pdx] [data-rp-tab="' + id + '"]');
    var acc = panel.querySelector('[data-rp-acc]');
    if (desktop && tab) {
      tab.click();
    } else if (acc && !panel.classList.contains('is-open')) {
      acc.click();
    }
    var target = desktop && tab ? tab : panel;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
